module.exports = __webpack_public_path__ + "static/media/br.46d00db1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/br.svg
// module id = 2052
// module chunks = 0